<mat-form-field appearance="outline" class="search-field">
  <input matInput (keyup)="applyFilter($event)" placeholder="Sök försändelse" />
</mat-form-field>

<div class="table-wrapper">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="AssignedTimestamp">
      <th mat-header-cell *matHeaderCellDef>Inlämnad</th>
      <td mat-cell *matCellDef="let shipment">
        {{ formatDate(shipment.AssignedTimestamp) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Courier">
      <th mat-header-cell *matHeaderCellDef>Speditör</th>
      <td mat-cell *matCellDef="let shipment">{{ shipment.Courier | titlecase }}</td>
    </ng-container>
    <ng-container matColumnDef="ShipmentId">
      <th mat-header-cell *matHeaderCellDef>Shipment ID</th>
      <td mat-cell *matCellDef="let shipment">
        <a [href]="shipment.trackingUrl" target="_blank">
          {{ shipment.ShipmentId }}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="SalesPersonId">
      <th mat-header-cell *matHeaderCellDef>SäljarId</th>
      <td mat-cell *matCellDef="let shipment">{{ shipment.SalesPersonId }}</td>
    </ng-container>
    <ng-container matColumnDef="SalesPersonName">
      <th mat-header-cell *matHeaderCellDef>Säljare</th>
      <td mat-cell *matCellDef="let shipment">
        {{ shipment.SalesPersonName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="CompanyName">
      <th mat-header-cell *matHeaderCellDef>Företag</th>
      <td mat-cell *matCellDef="let shipment">{{ shipment.CompanyName }}</td>
    </ng-container>
    <ng-container matColumnDef="Status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let shipment">
        {{ formatStatus(shipment.Status) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="PoNumber">
      <th mat-header-cell *matHeaderCellDef>PO-nummer</th>
      <td mat-cell *matCellDef="let shipment">{{ shipment.PoNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="CreditNumber">
      <th mat-header-cell *matHeaderCellDef>Kredit-nummer</th>
      <td mat-cell *matCellDef="let shipment">{{ shipment.CreditNumber }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns()"></tr>
  </table>
</div>
